module.exports = __webpack_public_path__ + "img/Olympique-Marseille.85169056.png";